var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrikethrough24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "m12.66 11.86-.76-.38c-1.34-.65-2.77-1.45-3.07-2.9-.08-.39-.1-.76-.03-1.06.1-.48.32-.94.63-1.36C10.86 4.2 13.67 4.83 16 5.5m-3.34 6.36c1.55.76 2.84 1.91 2.84 3.64 0 4.06-5.6 3.46-8 2.5m5.16-6.14H4m8.66 0H20",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough24);
export default __webpack_public_path__ + "static/media/strikethrough_24.8ff2e37ad7f9d9d8d43a2fbabe533047.svg";
export { ForwardRef as ReactComponent };